import { render, staticRenderFns } from "./DevTables.vue?vue&type=template&id=6811bf48&scoped=true"
import script from "./DevTables.vue?vue&type=script&lang=js"
export * from "./DevTables.vue?vue&type=script&lang=js"
import style0 from "./DevTables.vue?vue&type=style&index=0&id=6811bf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811bf48",
  null
  
)

export default component.exports